import React from 'react';
import { RadioField } from 'src/jbc-front/components/Form';
import styles from './DownloadCsvEncodingRadioButton.scss';
import { withTranslation } from 'react-i18next';

class DownloadCsvEncodingRadioButton extends React.Component {
  render() {
    return (
      <React.Fragment>
        <RadioField
          name={this.props.name}
          label={this.props.label}
          options={this.props.options}
          required={this.props.required}
        />
        {/* <div className={styles.note}>{this.props.t('components.DownloadCsvEncodingRadioButton.please_use_shift_jis')}</div> */}
      </React.Fragment>
    );
  }
}

export default withTranslation()(DownloadCsvEncodingRadioButton);
